/**
 * @file 特性列表
 * @author FengGuang(fengguang01@baidu.com)
 */

import React from 'react';
import listData from './featureListData';

const FeatureList: React.FC = () => {
    return (
        <div className="paddle-feature-list">
            {listData.map(item => (
                <div
                    key={item.title}
                    className="paddle-feature-list-item"
                >
                    <div className="paddle-feature-list-item-context-h1">
                        {item.title}
                    </div>
                    <div className="paddle-feature-list-item-context-h3">
                        {item.subtitle}
                    </div>
                    <div className="paddle-feature-list-item-link-wrap">
                        {
                            !!item.link
                            && <a
                                className="paddle-feature-list-item-link"
                                href={item.link}
                                target={item.target}
                                rel={item.target === '_blank' ? 'noopener noreferrer' : undefined}
                            >
                                查看详情
                            </a>
                        }
                    </div>
                    <div className="paddle-feature-list-item-img-wrap">
                        {
                            !!item.img
                            && <img
                                className="paddle-feature-list-item-img"
                                alt={item.title}
                                src={item.img}
                            />
                        }
                    </div>
                </div>
            ))}
        </div>
    );
};

export default FeatureList;
